export default __webpack_public_path__ + "static/media/ecar.ef4cda6a.jpg";